import { call, put, takeLatest } from "redux-saga/effects";

import {
  GET_ITEM_MBQ_MOQ,
  SAVE_ITEM_MBQ_MOQ,
  DELETE_ITEM_MBQ_MOQ
} from "./actionType";

import {
  getItemMBQMOQSuccess,
  saveItemMBQMOQSuccess,
  deleteItemMBQMOQSuccess,
  itemMBQMOQError,
  getItemMBQMOQ
} from "./actions";

import {
  Item_MBQ_MOQ_Get_API,
  Item_MBQ_MOQ_Post_API,
  Item_MBQ_MOQ_Delete_API
} from "../../../helpers/backend_helper";


// ================== GET ==================
function* Get_Item_MBQ_MOQ_GenFun({ config }) {
  try {

    const response = yield call(
      Item_MBQ_MOQ_Get_API,
      {
        partytype_id: config.partytype_id || 0,
        party_id: config.party_id || 0,
        CompanyID: config.CompanyID,
        GroupType: config.GroupType
      }
    );

    yield put(getItemMBQMOQSuccess(response.Data));

  } catch (error) {
    yield put(itemMBQMOQError());
  }
}

// ================== POST ==================
function* Save_Item_MBQ_MOQ_GenFun({ config }) {
  try {

    const response = yield call(Item_MBQ_MOQ_Post_API, {
      jsonBody: config.jsonBody
    });

    yield put(saveItemMBQMOQSuccess(response));

  } catch (error) {
    yield put(itemMBQMOQError());
  }
}


function* Delete_Item_MBQ_MOQ_GenFun({ config }) {
  try {

    const response = yield call(Item_MBQ_MOQ_Delete_API, {
      id: config.id,
      jsonBody: {
        party_id: config.party_id,
        partytype_id: config.partytype_id
      }
    });

    // Always send delete response to reducer
    yield put(deleteItemMBQMOQSuccess(response));

    // GET API ONLY when DELETE is successful
    if (response?.StatusCode === 200) {
      yield put(getItemMBQMOQ({
        party_id: config.party_id,
        partytype_id: config.partytype_id,
        CompanyID: config.CompanyID,
        GroupType: 1
      }));
    }

  } catch (error) {
    yield put(itemMBQMOQError());
  }
}


// ================== ROOT ==================
function* ItemMBQMOQSaga() {
  yield takeLatest(GET_ITEM_MBQ_MOQ, Get_Item_MBQ_MOQ_GenFun);
  yield takeLatest(SAVE_ITEM_MBQ_MOQ, Save_Item_MBQ_MOQ_GenFun);
  yield takeLatest(DELETE_ITEM_MBQ_MOQ, Delete_Item_MBQ_MOQ_GenFun);
}

export default ItemMBQMOQSaga;